<template>
  <div :id="projectName" :name="projectName" class="nnd-app">
    <div class="nnd-container">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
  import project from '../../project'
  // import database from '../assets/data/data.json'

  import router from '@/router'

  export default {
    name: `app_${project.name}`,
    data() {
      return {
        author: 'Vasik Dabhoiwala',
        projectName: `app_${project.name}`,
        env: process.env.NODE_ENV
      }    
    },
    methods: {
      changeNav(tab) {
        this.tab = tab
        router.push({
          name: tab
        })
      },
      checkAppWidth () {
        let contEl = document.getElementById(`app_${project.name}`)
        contEl.classList.remove('nnd-story-desktop')
        if (contEl.offsetWidth < 900 && contEl.offsetWidth > 550) {
          contEl.classList.add('nnd-story-desktop')
        }
      }
    },
    mounted () {
      this.checkAppWidth()
      window.addEventListener('resize', this.checkAppWidth)
    }
  }
</script>

<style lang="scss">
    /* global */
    @import "src/assets/styles/app";
</style>



// WEBPACK FOOTER //
// src/components/App.vue